class Cabinet {
	constructor() {
		this.selectors = {
			document: document,	
			add_Cart: '.js-add-to-cart',		
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {	
		// Button adds product to Cart
		this.nodes.document.on('click', this.selectors.add_Cart, (e) => {
			e.preventDefault();
			console.log('added')
			var $this = $(e.currentTarget),
				imgToDrag = $this.closest('.js-content').find("img:not(.brand_img, .moldova_img)").eq(0),				
				cart = $('.js-cart').filter(':visible'),
				cartCount = $('.js-cart-count').filter(':visible'),
				total_count = 0,
				url = $this.attr('data-href'),
				count = 1,
				action = true,
				quantity = $this.closest('.js-content').find('.js-quantity');
			if (quantity.length > 0 ){
				url = url + '&products_count=' + quantity.val()
				count = parseInt(quantity.val())
			}
			$this.hasClass('disabled') ? action = false : action = true;
			if (action) {
				$.ajax({
					url: url,
					type: 'POST',
					success: function(result) {
						// console.log(result)
						if (result.success == true) {
							// Cart count
							total_count = parseInt(cartCount.text()) + count;
							if (result.total_count <= 999) {
								cartCount.text(total_count);								
							} else
								cartCount.text('999+');

							// Product image flies to cart
							if (imgToDrag) {
								var imgClone = imgToDrag.clone()
									.offset({
										top: imgToDrag.offset().top,
										left: imgToDrag.offset().left
									})
									.css({
										'opacity': '0.5',
										'position': 'absolute',
										'height': '150px',
										'width': '150px',
										'z-index': '100'
									})
									.appendTo($('body'))
									.animate({
										'top': cart.offset().top + 10,
										'left': cart.offset().left + 10,
										'width': 75,
										'height': 75
									}, 1000, 'easeInOutExpo');
								imgClone.animate({
									'width': 0,
									'height': 0
								});
							}
						}
					}
				});
			}
		});
		function LoginPopup(cabinetTag) {
			$(cabinetTag).on('click', e => {
				if (typeof TOPBAR !== 'undefined' && !TOPBAR.isLogined() ){
					e.preventDefault();					
					TOPBAR.popup('login');
				}
			})
		}	
		LoginPopup('#js-cabinet');
		LoginPopup('#js-cabinet-mobile');		
    }
}
new Cabinet();